<template>
  <BaseCard head="customer_details" :hasBack="true" class="lg:max-w-4xl" size="lg">
    <base-loader :fetching="pendingComponentInit" />
    <company-form
      v-if="!pendingComponentInit"
      :mode="'create'"
      @created="onClose"
      @close="onClose"
    />
  </BaseCard>
</template>

<script>
import {BaseLoader, BaseCard} from '@/components/base'
import CompanyForm from './CompanyForm.vue'

export default {
  components: {
    BaseLoader,
    BaseCard,
    CompanyForm,
  },

  data() {
    return {
      pendingComponentInit: false,
    }
  },

  created() {
    //this._initComponent();
  },

  methods: {
    onClose() {
      this.$router.back()
    },

    async _initComponent() {
      try {
        this.pendingComponentInit = true
        await this.$store.dispatch('companies/getAll')
      } catch (e) {
        console.log(e)
      } finally {
        setTimeout(() => (this.pendingComponentInit = false), 800)
      }
    },
  },
}
</script>
